import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import {
  FaStar,
  FaMicrochip,
  FaCogs,
  FaProjectDiagram,
} from 'react-icons/fa';

const AboutZapRF = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className="space-y-8 animate-fadeIn">
      {/* What's New Section */}
      <section>
        <div className="flex items-center space-x-3 mb-4">
          <h3 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            What's New
          </h3>
        </div>
        <div className={`p-6 rounded-xl border ${
          isDarkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'
        } shadow-sm`}>
          <ul className={`space-y-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            <li className="flex items-start space-x-3">
              <FaMicrochip className="mt-1 text-brand-purple w-6 h-6 flex-shrink-0" />
              <span>
                Pilot version supports multi-frequency targets, letting the user specify Z goals per frequency point and include S11/S21 targets with tunable weights.
              </span>
            </li>
            <li className="flex items-start space-x-3">
              <FaCogs className="mt-1 text-brand-purple w-6 h-6 flex-shrink-0" />
              <span>
                The application UI is predictable and easier to run repeatedly. Optimization is bounded by a max EM-evaluation/iteration limit, can stop early once a cost threshold is met, and saves the run configuration for traceability.
              </span>
            </li>
            <li className="flex items-start space-x-3">
              <FaProjectDiagram className="mt-1 text-brand-purple w-6 h-6 flex-shrink-0" />
              <span>
                ZapRF iteratively adjusts selected design parameters, launches ADS EM simulations, and drives an optimizer to converge the as-built layout EM response toward your targets.
              </span>
            </li>
          </ul>
        </div>
      </section>

      {/* Product Features Section */}
      <section>
        <div className="flex items-center space-x-3 mb-4">
          <h3 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Key Features
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className={`p-6 rounded-xl border ${
            isDarkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'
          } shadow-sm`}>
            <div className="flex items-center space-x-3 mb-2">
              <FaStar className="text-brand-red w-5 h-5" />
              <h4 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                EM optimization that matches design intent
              </h4>
            </div>
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Results can be renormalized to your intended source/load impedances (not just 50 Ω), with optional conjugate matching behavior so the optimized outcome aligns with real termination conditions.
            </p>
          </div>
          <div className={`p-6 rounded-xl border ${
            isDarkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-white border-gray-200'
          } shadow-sm`}>
            <div className="flex items-center space-x-3 mb-2">
              <FaStar className="text-brand-red w-5 h-5" />
              <h4 className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Review EM Runs
              </h4>
            </div>
            <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Each run reports initial vs. optimized impedance/S-parameter metrics, the final cost and stopping reason, and the optimized parameter values so you can review changes and apply them with confidence.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutZapRF;

